module.exports = __webpack_public_path__ + "img/cert-front.3ff8911f.svg";